<template>
<div class="chapter">
<div class="inner_page">
<p class="crt-2"><span epub:type="pagebreak" id="page_vi" title="vi"> T<span class="small">HE</span> E<span class="small">NEMY IN</span> Y<span class="small">OU</span>: J<span class="small">OURNEY</span> F<span class="small">ROM</span> B<span class="small">ROKENNESS TO</span> W<span class="small">HOLENESS</span></span></p>
<p class="crt">by Johnny Honaker</p>
<p class="crt">Published by Creation House</p>
<p class="crt">A Charisma Media Company</p>
<p class="crt">600 Rinehart Road</p>
<p class="crt">Lake Mary, Florida 32746</p>
<p class="crt"><a href="http://www.charismamedia.com" id="AxX" target="_blank">www.charismamedia.com</a></p>
<p class="crt-1">This book or parts thereof may not be reproduced in any form, stored in a retrieval system, or transmitted in any form by any means—electronic, mechanical, photocopy, recording, or otherwise—without prior written permission of the publisher, except as provided by United States of America copyright law.</p>
<p class="crt-1">Unless otherwise noted, all Scripture quotations are from the Holy Bible, New International Version<sup>®</sup>, NIV<sup>®</sup>. Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.™ Used by permission of Zondervan. All rights reserved worldwide.</p>
<p class="crt-1">Scripture quotations marked <span class="small">AMP</span> are from the Amplified Bible. Copyright © 1954, 1958, 1962, 1964, 1965, 1987 by The Lockman Foundation. Used by permission.</p>
<p class="crt-1">Scripture quotations marked <span class="small">ESV</span> are from the Holy Bible, English Standard Version. Copyright © 2001 by Crossway Bibles, a division of Good News Publishers. Used by permission.</p>
<p class="crt-1">Scripture quotations marked <span class="small">KJV</span> are from the King James Version of the Bible.</p>
<p class="crt-1">Scripture quotations marked <span class="small">NKJV</span> are taken from the New King James Version<sup>®</sup>. Copyright © 1982 by Thomas Nelson. Used by permission.</p>
<p class="crt-1">Scripture quotations marked <span class="small">NLT</span> are from the Holy Bible, New Living Translation, copyright © 1996, 2004, 2007. Used <span epub:type="pagebreak" id="page_vii" title="vii">by permission of Tyndale House Publishers, Inc., Wheaton, IL 60189. All rights reserved.</span></p>
<p class="crt-1">Cover design by Jon Minuto</p>
<p class="crt-1">Copyright © 2017 by Johnny Honaker</p>
<p class="crt">All rights reserved.</p>
<p class="crt-1">Visit the author’s website: <a href="http://TheEnemyInYou.com" id="ADU" target="_blank">TheEnemyInYou.com</a></p>
<p class="crt-1">Library of Congress Control Number: 2017940143</p>
<p class="crt">International Standard Book Number: 978-1-62999-215-0</p>
<p class="crt">E-book International Standard Book Number: 978-1-62999-216-7</p>
<p class="crt-1">While the author has made every effort to provide accurate telephone numbers and Internet addresses at the time of publication, neither the publisher nor the author assumes any responsibility for errors or for changes that occur after publication.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?183f38a5